import { ref, onMounted, watch } from 'vue';
const useThrottleRender = function (loading) {
  let throttle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (throttle === 0) return loading;
  const throttled = ref(false);
  let timeoutHandle = 0;
  const dispatchThrottling = () => {
    if (timeoutHandle) {
      clearTimeout(timeoutHandle);
    }
    timeoutHandle = window.setTimeout(() => {
      throttled.value = loading.value;
    }, throttle);
  };
  onMounted(dispatchThrottling);
  watch(() => loading.value, val => {
    if (val) {
      dispatchThrottling();
    } else {
      throttled.value = val;
    }
  });
  return throttled;
};
export { useThrottleRender };